export const DASHBOARD_HOME_MOBILE_SCROLL_SELECTOR = '.dashboard-home-mobile-scroll';
export const DASHBOARD_HOME_SCROLL_TOP_THRESHOLD = 8;
export const DASHBOARD_HOME_NAVBAR_HIDDEN_CLASS = 'dashboard-home-mobile-navbar-hidden';

export function getDashboardHomeMobileScrollEl() {
	if (typeof document === 'undefined') {
		return null;
	}
	return document.querySelector(DASHBOARD_HOME_MOBILE_SCROLL_SELECTOR);
}

export function isDashboardHomeScrolled(threshold = DASHBOARD_HOME_SCROLL_TOP_THRESHOLD) {
	const scrollEl = getDashboardHomeMobileScrollEl();
	return scrollEl ? scrollEl.scrollTop > threshold : false;
}

/** 手机首页滚动回顶，并恢复顶栏 */
export function scrollDashboardHomeToTop({ smooth = true } = {}) {
	const scrollEl = getDashboardHomeMobileScrollEl();
	if (!scrollEl) {
		return false;
	}

	scrollEl.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
	document.body.classList.remove(DASHBOARD_HOME_NAVBAR_HIDDEN_CLASS);
	return true;
}
